import { createFileRoute } from '@tanstack/react-router'
import { useAuth } from '@/contexts/AuthContext'
import { AdminPanel } from '@/components/admin/AdminPanel'
import { ShieldAlert } from 'lucide-react'

export const Route = createFileRoute('/_authenticated/admin')({
  component: AdminPage,
})

function AdminPage() {
  const { isAdmin } = useAuth()

  if (!isAdmin) {
    return (
      <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4">
        <ShieldAlert
          className="h-16 w-16"
          style={{ color: 'var(--text-muted)' }}
        />
        <h1
          className="text-xl font-semibold"
          style={{ color: 'var(--text-primary)' }}
        >
          Brak uprawnień
        </h1>
        <p style={{ color: 'var(--text-muted)' }}>
          Tylko administratorzy mają dostęp do tego panelu.
        </p>
      </div>
    )
  }

  return <AdminPanel />
}
